export default __webpack_public_path__ + "static/media/beth.4b05906d.png";